import {Button} from '../Button'

const noop = () => {}

export function renderHeader(h, props, styles) {
  const actionsMarkup = (props.actions || [])
    .filter(d => d.visible !== false)
    .map(d => h(Button, {
      class: styles.action,
      props: {
        type: 'plain',
        disabled: d.disabled,
        url: d.url,
        external: d.external
      },
      on: {
        click: d.onAction || noop
      }
    }, d.label))

  if (props.title || actionsMarkup.length) {
    const content = []

    if (props.title) {
      content.push(
        h('div', {
          class: styles.title
        }, props.title)
      )
    }

    if (props.actions) {
      if (actionsMarkup) {
        content.push(
          h('div', {
            class: styles.actions
          }, actionsMarkup)
        )
      }
    }

    return h('div', {
      class: styles.header,
      attrs: {
        'data-card-header': true
      }
    }, content)
  }
}
